import { updates } from '@/mocks/home';
import Reveal from '@/pages/home/components/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

const indexLinks = [
  { href: '#category', label: '栏目导航', desc: '8 个方向入口', icon: 'ri-list-check-2' },
  { href: '#topic', label: '专题板块', desc: '24 个话题合集', icon: 'ri-stack-line' },
  { href: '#featured', label: '大图精选', desc: '封面优先卡片流', icon: 'ri-image-2-line' },
  { href: '#tags', label: '标签目录', desc: '5 组筛选维度', icon: 'ri-price-tag-3-line' },
];

export default function UpdateBoard() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="目录维护"
            icon="ri-history-line"
            title="目录发生了什么变化，都记在这"
            desc="新增、归档和排序调整都会留下一条记录。目录结构是持续维护的，更新记录让你知道最近动过哪些板块。"
          />
        </Reveal>

        <div className="mt-9 grid grid-cols-1 gap-5 lg:grid-cols-[1.4fr_1fr]">
          <Reveal>
            <div className="h-full rounded-lg border border-background-200 bg-background-50">
              <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
                <h3 className="font-heading text-base font-semibold text-foreground-950">更新记录</h3>
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                  示例数据
                </span>
              </div>
              <ul className="divide-y divide-background-200">
                {updates.map((item) => (
                  <li key={item.time} className="flex items-start gap-4 px-5 py-4">
                    <span className="mt-0.5 shrink-0 font-label text-xs tabular-nums text-foreground-400">
                      {item.time}
                    </span>
                    <p className="flex-1 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                    <span className="shrink-0 rounded-full bg-primary-50 px-2.5 py-1 text-[11px] text-primary-700">
                      {item.tag}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950">目录索引</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                四个主要入口，按你现在的浏览意图直接跳转。
              </p>
              <div className="mt-5 flex flex-col gap-3">
                {indexLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="group flex items-center gap-3 rounded-md border border-background-200 bg-background-100 px-4 py-3 transition-colors hover:border-primary-300 hover:bg-background-50"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50">
                      <i className={`${link.icon} text-base`}></i>
                    </span>
                    <span className="flex-1">
                      <span className="block text-sm font-medium text-foreground-900">{link.label}</span>
                      <span className="block text-xs text-foreground-500">{link.desc}</span>
                    </span>
                    <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                      <i className="ri-arrow-right-s-line text-lg"></i>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}